import { render, staticRenderFns } from "./ImgFullscreen.vue?vue&type=template&id=7f8c6133&scoped=true"
import script from "./ImgFullscreen.vue?vue&type=script&lang=ts"
export * from "./ImgFullscreen.vue?vue&type=script&lang=ts"
import style0 from "./ImgFullscreen.vue?vue&type=style&index=0&id=7f8c6133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8c6133",
  null
  
)

export default component.exports